<template lang="html">
  <v-container fluid class="px-sm-10">
    <v-row>
      <v-col>
        <items-view
          storeModule="giftcards"
          titleSingle="Gift Card"
          titleMultiple="Gift Cards"
          :headers="headers"
          :itemsMap="itemsMap"
          :itemsFilter="itemsFilter"
          defaultSort="created_at"
          defaultSortDesc
          noTitlePrefix
          cancel="Close"
          :saveEnabled="false"
          :deleteEnabled="false"
          :createEnabled="false"
        >
          <template #before-search="{items}">
            <v-checkbox
              label="Hide spent gift cards"
              v-model="hideSpentGiftCards"
            ></v-checkbox>

            <p class="body-1">
              {{items.length}} gift cards with a total current amount of {{items.reduce((a, item) => a + item.amount, 0)}} SEK
            </p>
          </template>

          <template #item.giftcard_number="{item}">
            <span>{{item.giftcard_number.slice(0,2)}}***{{item.giftcard_number.slice(-1)}}</span>
          </template>
          <template #item.amount="{item}">
            <span :class="{'text--disabled': item.amount == 0}">{{item.amount}} SEK</span>
          </template>
          <template #item.originalAmount="{item}">
            <span>{{item.originalAmount || 0}} SEK</span>
          </template>
          <template #item._useCount="{item}">
            <span :class="{'text--disabled': item._useCount == 0}">{{item._useCount}}</span>
          </template>
          <template #item.created_at="{item}">
            <span>{{(item.created_at || '').slice(0, 16)}}</span>
          </template>

          <template #itemForm="slotProps">
            <gift-card-form v-bind="slotProps" />
          </template>
        </items-view>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {ItemsView} from 'dync-baseitem';
import GiftCardForm from '../components/GiftCardForm.vue';

export default {
  name: 'GiftCards',
  data() {
    return {
      hideSpentGiftCards: true,
      headers: [
        {
          text: 'Code',
          value: 'giftcard_number'
        },
        {
          text: 'Current Amount',
          value: 'amount'
        },
        {
          text: 'Original Amount',
          value: 'originalAmount'
        },
        {
          text: 'Number of uses',
          value: '_useCount'
        },
        {
          text: 'Created at',
          value: 'created_at'
        }
      ]
    };
  },
  computed: {
    itemsFilter() {
      if (this.hideSpentGiftCards) {
        return {
          keyValue: [
            ['status', 'PAID']
          ]
        }
      }
      return null;
    }
  },
  methods: {
    itemsMap(item) {
      item = {...item};
      item._useCount = (item.usePayments || []).length;
      return item;
    }
  },
  components: {
    ItemsView,
    GiftCardForm
  }
}
</script>

<style lang="scss" scoped>
</style>
